/*
 * Public API Surface of angularx-flatpickr
 */

export * from './lib/flatpickr.module';
export { FlatpickrDefaults, FlatpickrDefaultsInterface } from './lib/flatpickr-defaults.service';
export { FlatpickrDirective } from './lib/flatpickr.directive';
